import { createAsyncThunk } from '@reduxjs/toolkit';
import { RegistrationRejectionReasons } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchRegistrationRejectionReason,
  FindRegistrationRejectionReasons,
} from './interface';

export const findRegistrationRejectionReasons = createAsyncThunk(
  'registrationRejectionReasons/find',
  async (values: FindRegistrationRejectionReasons, { rejectWithValue }) => {
    try {
      const response = await RegistrationRejectionReasons.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createRegistrationRejectionReason = createAsyncThunk(
  'registrationRejectionReasons/create',
  async (
    values: CreatePatchRegistrationRejectionReason,
    { rejectWithValue }
  ) => {
    try {
      const response = await RegistrationRejectionReasons.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchRegistrationRejectionReason = createAsyncThunk(
  'registrationRejectionReasons/patch',
  async (
    { id, ...values }: CreatePatchRegistrationRejectionReason,
    { rejectWithValue }
  ) => {
    try {
      const response = await RegistrationRejectionReasons.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const removeRegistrationRejectionReason = createAsyncThunk(
  'registrationRejectionReasons/remove',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await RegistrationRejectionReasons.remove(id);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
